import { SaveBase } from "./SaveBase";
import { Matrix } from "../../../maths/Matrix";
import { Rectangle } from "../../../maths/Rectangle";
import { Const } from "../../../Const";
export class SaveClipRect {
    constructor() {
        this._globalClipMatrix = new Matrix();
        this._clipInfoID = -1;
        this._clipRect = new Rectangle();
        this._clip_x = 0;
        this._clip_y = 0;
    }
    isSaveMark() { return false; }
    restore(runner) {
        if (this._clipRect.width == SaveClipRect.MAX.width
            && this._clipRect.height == SaveClipRect.MAX.height
            && this._clip_x == SaveClipRect.MAX.x
            && this._clip_y == SaveClipRect.MAX.y) {
            runner._clipRect = SaveClipRect.MAX;
        }
        else {
            this._clipRect.clone(runner._clipRect);
        }
        runner._clip_x = this._clip_x;
        runner._clip_y = this._clip_y;
        this._globalClipMatrix.copyTo(runner._globalClipMatrix);
        runner._clipInfoID = this._clipInfoID;
        SaveClipRect.POOL[SaveClipRect.POOL._length++] = this;
    }
    static save(runner) {
        if ((runner._saveMark._saveuse & SaveBase.TYPE_CLIPRECT) == SaveBase.TYPE_CLIPRECT)
            return;
        runner._saveMark._saveuse |= SaveBase.TYPE_CLIPRECT;
        var cache = SaveClipRect.POOL;
        var o = cache._length > 0 ? cache[--cache._length] : (new SaveClipRect());
        runner._globalClipMatrix.copyTo(o._globalClipMatrix);
        runner._clipRect.clone(o._clipRect);
        o._clipInfoID = runner._clipInfoID;
        o._clip_x = runner._clip_x;
        o._clip_y = runner._clip_y;
        var _save = runner._save;
        _save[_save._length++] = o;
    }
}
SaveClipRect.MAX = new Rectangle(0, 0, Const.MAX_CLIP_SIZE, Const.MAX_CLIP_SIZE);
SaveClipRect.POOL = SaveBase._createArray();
